import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343fdbe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-staked-account" }
const _hoisted_2 = { class: "stake-staked-account__item" }
const _hoisted_3 = { class: "stake-staked-account__item-info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "stake-staked-account__item-block" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "stake-staked-account__item-action" }
const _hoisted_8 = { class: "stake-staked-account__item-action-info" }
const _hoisted_9 = { class: "stake-staked-account__stats" }
const _hoisted_10 = { class: "stake-staked-account__stats-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Total staked", -1))
const _hoisted_12 = { class: "stake-staked-account__stats-block-amount" }
const _hoisted_13 = { class: "stake-staked-account__stats-block" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "stake-staked-account__stats-block-amount" }
const _hoisted_16 = { class: "stake-staked-account__stats-block" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Overall earnings", -1))
const _hoisted_18 = { class: "stake-staked-account__stats-block-amount" }
const _hoisted_19 = { class: "stake-staked-account__stats-block" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Overall yield", -1))
const _hoisted_21 = { class: "stake-staked-account__stats-block-amount" }
const _hoisted_22 = {
  key: 0,
  class: "stake-staked-account__validators-toggle"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "stake-staked-account__validators-list" }

import BaseButton from "@/components/base-button/index.vue";
import Expand from "@/icons/common/expand.vue";
import InfoTooltip from "@/components/info-tooltip/index.vue";
import StakeStakedValidators from "./stake-staked-validators.vue";
import { ref, PropType, computed } from "vue";
import { useRouter } from "vue-router";
import { StakingAccountWithValidators } from "@/types/staking";
import VueCountdown from "@chenfengyuan/vue-countdown";
import { nativeToken, unbondDuration } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-staked-account',
  props: {
  account: {
    type: Object as PropType<StakingAccountWithValidators>,
    default: null,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const isOpen = ref<boolean>(false);
const unbondInfo = `The unbonding period is approximately ${unbondDuration.value}.`;



const earningsPercent = computed(() => {
  return props.account.earnings.div(props.account.totalStaked).times(100);
});

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const unbondAction = () => {
  router.push({
    name: "stake-unbond",
    query: {
      address: props.account?.address,
    },
  });
};

const withdrawAction = () => {
  router.push({
    name: "stake-withdraw",
    query: {
      address: props.account?.address,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: __props.account?.image,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, [
            _createTextVNode(_toDisplayString(__props.account?.name) + " ", 1),
            (__props.account?.isLedger)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Ledger"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$filters.replaceWithEllipsis(__props.account?.address, 6, 6)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(" Unbond to withdraw funds "),
          _createVNode(InfoTooltip, { text: unbondInfo })
        ]),
        _createVNode(BaseButton, {
          title: "Unbond",
          stroke: true,
          small: true,
          action: unbondAction
        }),
        (!__props.account.withdrawable.isZero())
          ? (_openBlock(), _createBlock(BaseButton, {
              key: 0,
              title: "Withdraw",
              subtitle: `${_ctx.$filters.cryptoCurrencyFormat(
            __props.account.withdrawable.toNumber()
          )} ${_unref(nativeToken).symbol.toLocaleUpperCase()}`,
              stroke: true,
              small: true,
              action: withdrawAction
            }, null, 8, ["subtitle"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h5", null, [
            _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.account.activeStaked.toNumber())) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(nativeToken).symbol), 1)
          ]),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$filters.currencyFormat(
                __props.account.activeStaked.toNumber() * _unref(nativeToken).price.toNumber(),
                "USD"
              )), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", null, [
          _createTextVNode(" Unbonding "),
          (__props.account.unbondingList.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                _createVNode(_unref(VueCountdown), {
                  interval: 60000,
                  time: __props.account.unbondingList[0]?.timeInMs || 0
                }, {
                  default: _withCtx(({ days, hours, minutes }) => [
                    _createTextVNode(_toDisplayString(`(${days ? `${days}d ` : ""}${
                  hours ? `${hours}h ` : ""
                }${minutes}m left)`), 1)
                  ]),
                  _: 1
                }, 8, ["time"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h5", null, [
            _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.account.unbonding.toNumber())) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(nativeToken).symbol), 1)
          ]),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$filters.currencyFormat(
                __props.account.unbonding.toNumber() * _unref(nativeToken).price.toNumber(),
                "USD"
              )), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("h5", null, [
            _createTextVNode(_toDisplayString(__props.account.isLoading
                ? "--"
                : _ctx.$filters.cryptoCurrencyFormat(__props.account.earnings.toNumber())) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(nativeToken).symbol), 1)
          ]),
          _createElementVNode("h6", null, _toDisplayString(__props.account.isLoading
                ? ""
                : _ctx.$filters.currencyFormat(
                    __props.account.earnings.toNumber() * _unref(nativeToken).price.toNumber(),
                    "USD"
                  )), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("h5", null, _toDisplayString(__props.account.isLoading
                ? "--"
                : _ctx.$filters.cryptoCurrencyFormat(earningsPercent.value)) + "% ", 1)
        ])
      ])
    ]),
    (__props.account.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Loading validator info... "))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "stake-staked-account__validators-toggle",
            onClick: toggle
          }, [
            _createTextVNode(" Show " + _toDisplayString(__props.account.validators.length) + " validator(s) ", 1),
            _createVNode(Expand, {
              class: _normalizeClass({ open: isOpen.value })
            }, null, 8, ["class"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_24, [
            _createVNode(StakeStakedValidators, {
              validators: __props.account.validators,
              "bonded-amount": __props.account.activeStaked
            }, null, 8, ["validators", "bonded-amount"])
          ], 512), [
            [_vShow, isOpen.value]
          ])
        ]))
  ]))
}
}

})